export default "/kiban/_next/static/images/42_12L_1-10-1-967902ace67f1295d6c8915f7bdb1343.png";